import { Stack } from '@mui/material';
import {
  useGetGuestJourneyDetailsCardsQuery,
  useGetGuestJourneyDetailsDataQuery,
} from 'api/reports-service/guest-journey-hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import {
  detailsFilteredSearchParams,
  useDetailsSearchParams,
} from '../guest-journey.hooks';
import ReportFieldsLink from '../report-fields/report-fields-link.component';
import DetailsSegmentTable from './details-segment-table.component';
import DetailsSummaryCards from './details-summary-cards.component';

/**
 * Queries only send the params on this tab's filter bar (Locations + Date Range
 * + Customer Type).
 */
const filteredSearchParams = detailsFilteredSearchParams;

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useDetailsSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Details />
    </SearchParamsProvider>
  );
};

const Details = () => {
  const summary = useSearchQuery(useGetGuestJourneyDetailsCardsQuery, {
    filteredSearchParams,
  });
  const details = useSearchQuery(useGetGuestJourneyDetailsDataQuery, {
    filteredSearchParams,
  });

  const groups = details.data?.groups ?? [];
  // The exact wire filters this table was built from (locations, date range,
  // customer type) — forwarded to each row's customer-list export so it matches
  // the on-screen view.
  const exportParams = details.queryState.originalArgs as
    | Record<string, unknown>
    | undefined;

  return (
    <Stack marginTop={2} data-testid="GuestJourney.Details">
      <MultipleSearchQueryProvider
        value={{
          queries: {
            summary,
            details,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />

          <ReportFieldsLink tab="details" />

          <DetailsSummaryCards
            data={summary.data}
            loading={summary.queryState.isFetching}
          />

          {groups.map((group, index) => (
            <DetailsSegmentTable
              key={group.label || index}
              visitTierName={group.label}
              rows={group.rows}
              loading={details.queryState.isFetching}
              exportParams={exportParams}
              data-testid={`Details.SegmentTable.${index}`}
            />
          ))}
        </Stack>
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default SearchParamsWrapper;
